/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetPreSignInDataRequest} from '@cash-web/protos/squareup/cash/usher/api/v1/get_pre_sign_in_data.pb'
import {GetPreSignInDataResponse} from '@cash-web/protos/squareup/cash/usher/api/v1/get_pre_sign_in_data.pb'


export const getPreSignInData = (request:GetPreSignInDataRequest, options?: CashRequestOptions) => post<GetPreSignInDataRequest, GetPreSignInDataResponse>("/2.0/cash/get-pre-sign-in-data", request, {...options, rejectOnError: true })